export const fallbackUrls = {

}